import React from 'react'
import PropTypes from 'prop-types'
import { useRecoilValueLoadable } from 'recoil'
import { resultsMessageHasThumb } from '../../../recoil/state/results'
import { STORE_KEY_ACCOUNT } from 'Constants/'
import {
  ThumbContainer,
  Thumb,
  Spinner,
  ThumbDefaultOverlay
} from 'mailup-web-components'

import { storeGet } from 'Helpers/localStorage'

const ResultThumbnail = ({ onClick, messageId }) => {
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)

  const { state } = useRecoilValueLoadable(resultsMessageHasThumb(messageId))

  const src = ['loading', 'hasError'].includes(state)
    ? `//${Domain}/css/img/no-image-preview-emailList.png`
    : `//${Domain}/messagepreview/${messageId}_90x110.jpg?ts=${Date.now()}`

  return (
    <ThumbContainer>
      <Thumb
        aspectRatio={90 / 110}
        onClick={onClick}
        className='test-openPreview'
        HoverComponent={ThumbDefaultOverlay}
        data-mu-test='result__thumb'
        src={src}
      >
        {state === 'loading' && <Spinner />}
        {state !== 'loading' && <img src={src} />}
      </Thumb>
    </ThumbContainer>
  )
}

ResultThumbnail.propTypes = {
  onClick: PropTypes.func,
  messageId: PropTypes.number
}

export default ResultThumbnail
